import React from 'react';
import { RefreshCw } from 'lucide-react';
import { cn } from '../cn';
import { accentStyle } from './accents';
import { PERIOD_LABEL } from './periods';
function formatInstant(iso, timeZone) {
    return new Intl.DateTimeFormat('en-GB', {
        timeZone,
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
    }).format(new Date(iso));
}
function formatTimezoneLabel(timeZone) {
    var _a, _b;
    try {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone,
            timeZoneName: 'shortOffset',
        }).formatToParts(new Date());
        const offset = (_b = (_a = parts.find((p) => p.type === 'timeZoneName')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
        return `${offset} · ${timeZone}`.trim();
    }
    catch {
        return timeZone;
    }
}
/** Resolved period range + data-as-of strip with an optional Refresh button. */
export const DashboardRangeBar = ({ envelope, onRefresh, refreshing = false, accent = 'orange', className, }) => {
    var _a;
    if (!envelope)
        return null;
    const a = accentStyle(accent);
    const periodLabel = (_a = PERIOD_LABEL[envelope.period]) !== null && _a !== void 0 ? _a : envelope.period;
    const rangeLabel = `${formatInstant(envelope.range_start, envelope.timezone)} → ${formatInstant(envelope.range_end, envelope.timezone)}`;
    return (React.createElement("div", { className: cn('flex flex-col gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3 sm:flex-row sm:items-center sm:justify-between', className) },
        React.createElement("div", { className: "min-w-0 space-y-1 text-xs text-gray-500" },
            React.createElement("p", { className: "font-medium text-gray-800" },
                periodLabel,
                " \u00B7 ",
                rangeLabel,
                ' ',
                React.createElement("span", { className: "font-normal text-gray-500" },
                    "(",
                    formatTimezoneLabel(envelope.timezone),
                    ")")),
            React.createElement("p", null,
                "Data as of ",
                formatInstant(envelope.data_as_of, envelope.timezone))),
        onRefresh && (React.createElement("button", { type: "button", onClick: onRefresh, disabled: refreshing, className: cn('inline-flex shrink-0 items-center self-start rounded-lg border bg-white px-3 py-1.5 text-sm font-medium disabled:opacity-60 sm:self-auto', a.rangeRefresh) },
            React.createElement(RefreshCw, { className: cn('mr-2 h-4 w-4', refreshing && 'animate-spin') }),
            "Refresh"))));
};
export default DashboardRangeBar;
